<template>
  <div>
    <mul-set-commission-rate ref="mulSetCommissionRef" @handleUpdateRate="handleUpdateRate"></mul-set-commission-rate>
    <el-dialog
        title="选择商品"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        top="4vh"
        width="1000px">
      <template #default>
        <div class="forms-container" style="display: flex;gap: 10px;justify-content: flex-end;margin-bottom: 10px;">
          <el-button type="primary" @click="handleMulSetCommissionRate">批量设置佣金比例</el-button>
        </div>
        <div class="forms-container">
          <el-form :model="searchForm" class="search-form" ref="searchFormRef">
            <el-form-item prop="productIdStr">
              <el-input
                  style="width:300px"
                  v-model="searchForm.productIdStr"
                  placeholder="商品ID，多个用逗号分隔"
              />
            </el-form-item>
            <el-form-item prop="nameLike">
              <el-input
                  style="width:300px"
                  :maxlength="100"
                  v-model="searchForm.nameLike"
                  placeholder="商品名称"
              />
            </el-form-item>
            <el-form-item>
              <!-- 操作按钮 -->
              <el-button type="warning" @click="onFormSearch">查询</el-button>
              <el-button type="warning" plain @click="onFormReset">重置</el-button>
            </el-form-item>
          </el-form>
          <div style="margin-bottom: 10px">
            已选中: {{multipleSelection.length}} 条数据
          </div>
        </div>
        <el-table
            :data="tableList.list"
            v-loading="loading"
            @selection-change="handleSelectionChange"
            highlight-current-row
            border
            max-height="500px"
            style="width: 100%">
          <el-table-column
              type="selection"
              width="55">
          </el-table-column>
          <el-table-column prop="templateCode" label="商品ID" width="230"/>
          <el-table-column prop="name" label="商品名称" />
          <el-table-column prop="commissionRate" width="150" label="佣金比例" >
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;gap: 10px">
                <el-input v-model="scope.row.commissionRate" @input=" value => { handleInput(value, scope.row)}"/>
                <div>%</div>
              </div>
              <div style="color: red" v-if="scope.row.customErrorMsg">
                {{ scope.row.customErrorMsg }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="tableList.total > 0"
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableList.currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="tableList.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableList.total"
        >
        </el-pagination>
      </template>
      <template #footer>
        <div style="display: flex;justify-content: flex-end;gap: 10px;">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import mini from "@/api/poi";
import GroupSettingPop from "./groupSettingPop.vue";
import MulSetCommissionRate from "./mulSetCommissionRate.vue";
import {formatPositiveIntegerInput} from "../../../../../utils/regExp";
const MiniModel = new mini();

export default {
  components: {
    GroupSettingPop,
    MulSetCommissionRate
  },
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        productIdStr: '',
        nameLike: '',
      },
      multipleSelection:[],
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      loading: false,
      tableList:{
        pageSize: 10,
        currentPage: 1,
        total: 0,
        list:[],
      },
    };
  },
  methods: {
    handleMulSetCommissionRate(){
      if(this.multipleSelection.length === 0){
        this.$message.warning('请选择商品')
        return;
      }
      this.$refs.mulSetCommissionRef.open()
    },
    handleUpdateRate(value){
      this.handleClearValidate()
      const filter = this.multipleSelection.map((item) => item.id)
      this.tableList.list.filter((data => {
        return filter.includes(data.id)
      })).forEach(item=>{
        this.$nextTick(()=>{
          this.$set(item,"commissionRate", value)
        })
      })
    },
    handleInput(value,item){
      this.$nextTick(()=>{
        this.$set(item,"customErrorMsg", '')
        item.commissionRate = formatPositiveIntegerInput(value)
      })
    },
    handleClearValidate(){
      this.tableList.list.forEach((item) => {
        this.$set(item,"customErrorMsg", '')
      })
    },
    async handValidate(){
      const filter = this.multipleSelection.map((item) => item.id)
      return new Promise((resolve, reject)=>{
        this.handleClearValidate()
        this.tableList.list.filter((data => {
          return filter.includes(data.id)
        })).forEach(item=>{
          if(!item.commissionRate){
            this.$set(item,"customErrorMsg", '请输入1-60的整数')
          }else if( item.commissionRate < 1 || item.commissionRate > 60){
            this.$set(item,"customErrorMsg", '请输入1-60的整数')
          }
        })

        const flag = this.tableList.list.some(item => item.customErrorMsg)
        if(flag){
          return reject('表单校验未通过')
        }else{
          return resolve(true)
        }
      })
    },
    handleClose(){
      this.dialogVisible = false
    },
    async handleConfirm(){
      if(this.multipleSelection.length === 0){
        this.$message.warning('请选择商品')
        return;
      }
      // 表格校验
      await this.handValidate()
      this.$emit('handleConfirm',this.multipleSelection)
      this.handleClose()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    open(){
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.dialogVisible = true
      this.getList()
    },
    async getList() {
      this.loading = true
      const res = await MiniModel.getChooseList({
        ...this.searchForm,
        pageNo: this.params.pageNo,
        pageSize: this.params.pageSize,
      });
      if(res.data.code !== 200) {
        this.$message.error(res.data.message);
        return;
      }
      this.tableList.list = res.data.data.list || [];
      this.tableList.total = res.data.data.total || 0;
      this.loading = false;
      this.tableList.currentPage = res.data.data.pageNo;
      this.tableList.pageSize = res.data.data.pageSize;
    },
    // 表单搜素
    onFormSearch() {
      debounce(
          () => {
            this.$refs['searchFormRef'].validate((valid) => {
              if (valid) {
                this.params.pageNo = 1;
                this.getList();
              } else {
                console.log('error submit!!');
                return false;
              }
            });
          },
          500,
          true
      );
    },
    reset() {
      this.searchForm = {
        productIdStr: '',
        nameLike: '',
      }
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.$refs['searchFormRef'].resetFields();
    },
    onFormReset() {
      debounce(() => {
        this.reset()
        this.getList()
      }, 1000, true)
    },
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getList();
    },
  }
};
</script>

<style scoped lang="less">
.pagination{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/groupSelectProductPop.vue